import React from "react";
import { InfoCard } from "source/tasks/components/TaskPanel/InfoCard";
import { parseGraphQLId } from "source/tasks/helpers";
import { useSegment } from "analytics/segment";
import { TaskUnit } from "core/queries/GetTask";

interface UnitInfoCardProps {
  taskId: string;
  unit: TaskUnit;
}
export const UnitInfoCard = ({ taskId, unit }: UnitInfoCardProps) => {
  const { address, id: unitId, images, internalRef } = unit;

  const { track } = useSegment();

  const avatarUrl = images[0]?.url;

  const onClick = () => {
    track({
      eventName: "task_panel",
      action: "click",
      element: "inquiry_link_unit",
      props: { taskId },
    });
    window.open(`${ADMIN_HOST}/units/${parseGraphQLId(unitId)}`, "_blank");
  };

  return (
    <InfoCard
      avatarName="N/A"
      avatarUrl={avatarUrl}
      subtext={address}
      text={internalRef}
      onClick={onClick}
    />
  );
};
